import { Injectable } from '@angular/core';
import { AccountService } from '../shared/services/account.service';
import { AuthServerProvider } from './auth-jwt.service';
import { HttpClient } from '@angular/common/http';
import {
  forgotPasswordUrl,
  resetPasswordUrl
} from '../../constants/url-constants';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(
    private accountService: AccountService,
    private authServerProvider: AuthServerProvider,
    private httpClient: HttpClient
  ) {}

  login(credentials, callback?) {
    const cb = callback || function() {};

    return new Promise((resolve, reject) => {
      this.authServerProvider.login(credentials).subscribe(
        data => {
          this.accountService.identity(true).then(account => {
            resolve(data);
          });
          return cb();
        },
        err => {
          this.logout();
          reject(err);
          return cb(err);
        }
      );
    });
  }

  loginWithToken(jwt, rememberMe) {
    return this.authServerProvider.loginWithToken(jwt, rememberMe);
  }

  logout() {
    this.authServerProvider
      .logout()
      .subscribe(() => this.accountService.authenticate(null));
  }

  forgotPassword(data) {
    return this.httpClient.post(forgotPasswordUrl, data);
  }

  resetPassword(data) {
    return this.httpClient.post(resetPasswordUrl, data);
  }
}
